import { render, staticRenderFns } from "./NoLibraryBagicTable.vue?vue&type=template&id=4988c580&scoped=true"
import script from "./NoLibraryBagicTable.vue?vue&type=script&lang=js"
export * from "./NoLibraryBagicTable.vue?vue&type=script&lang=js"
import style0 from "./NoLibraryBagicTable.vue?vue&type=style&index=0&id=4988c580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4988c580",
  null
  
)

export default component.exports